// Solana imports removed

const { ethers, Contract } = require("ethers");

// Use standard ERC20 ABI only
const ERC20 = require("./swapping/build/ERC20.json");
const PAIR = require("./swapping/build/IUniswapV2Pair.json"); 
const FACTORY = require("./swapping/build/IUniswapV2Factory.json");
const ROUTER = require("./swapping/build/UniswapV2Router02.json"); 

// Solana ABIs removed

//const contractAddress = "0xdD218BD2B591Ce02782a1028dad9d314A5e1e7eA"; // Replace with actual contract address
const ethprovider = new ethers.JsonRpcProvider(
  "https://ethereum-mainnet.core.chainstack.com/7cb41e194623a44e5dfa5b00dff031ad/"
); 
const EthcontractUni = new ethers.Contract("0x9a27cb5ae0B2cEe0bb71f9A85C0D60f3920757B4", FACTORY.abi, ethprovider);
const EthRouterAddress = "0xCEDd366065A146a039B92Db35756ecD7688FCC77";
const EthRouterSwap = new ethers.Contract(EthRouterAddress, ROUTER.abi, ethprovider);

function getRelativeTime(timestamp) {
  const now = Date.now();
  const diffInSeconds = Math.floor((now - timestamp) / 1000);

  if (diffInSeconds < 60) {
    return `${diffInSeconds}s ago`;
  } else if (diffInSeconds < 3600) {
    const minutes = Math.floor(diffInSeconds / 60);
    return `${minutes} min${minutes > 1 ? 's' : ''} ago`;
  } else if (diffInSeconds < 86400) {
    const hours = Math.floor(diffInSeconds / 3600);
    return `${hours} hr${hours > 1 ? 's' : ''} ago`;
  } else {
    const days = Math.floor(diffInSeconds / 86400);
    return `${days} day${days > 1 ? 's' : ''} ago`;
  }
}

// FIX DECIMALS ETH AMOUNT (DONE)
// NOTE: Many RPC providers enforce eth_getLogs block-range limits. Keep the lookback small and retry with smaller ranges if needed.
async function fetchRecentSwapEvents(address,tokenCA,chain) { //args: pair, token,chain
  let providerChain = ethprovider;
  let RouterChain = EthRouterAddress;
  // Keep this conservative to avoid "Block range limit exceeded" errors.
  // 2,000 blocks ≈ 6.6 hours on Ethereum (12s blocks).
  const DEFAULT_LOOKBACK_BLOCKS = 2000;
  const MIN_LOOKBACK_BLOCKS = 200;

  const currentBlock = await providerChain.getBlockNumber();
  let lookbackBlocks = DEFAULT_LOOKBACK_BLOCKS;
  let pastBlock = Math.max(0, currentBlock - lookbackBlocks);

  const CONTRACT_ADDRESS = address;
  //console.log(CONTRACT_ADDRESS)
  const CONTRACT_ABI = [
    {
      "anonymous": false,
      "inputs": [
        { "indexed": true, "internalType": "address", "name": "sender", "type": "address" },
        { "indexed": false, "internalType": "uint256", "name": "amount0In", "type": "uint256" },
        { "indexed": false, "internalType": "uint256", "name": "amount1In", "type": "uint256" },
        { "indexed": false, "internalType": "uint256", "name": "amount0Out", "type": "uint256" },
        { "indexed": false, "internalType": "uint256", "name": "amount1Out", "type": "uint256" },
        { "indexed": true, "internalType": "address", "name": "to", "type": "address" }
      ],
      "name": "Swap",
      "type": "event"
    }
  ];
  const contractHistory = new ethers.Contract(CONTRACT_ADDRESS, CONTRACT_ABI, providerChain);

  // Retry on providers with strict range limits by shrinking the requested window.
  let logs = [];
  for (let attempt = 0; attempt < 5; attempt++) {
    try {
      logs = await contractHistory.queryFilter(
        contractHistory.filters.Swap(),
        pastBlock,
        currentBlock
      );
      break;
    } catch (err) {
      const msg = (err && (err.message || err.toString())) || "";
      const code = err && err.code;
      const isRangeLimit =
        code === "UNKNOWN_ERROR" ||
        msg.toLowerCase().includes("block range limit exceeded") ||
        msg.toLowerCase().includes("range limit");

      if (!isRangeLimit) throw err;
      if (lookbackBlocks <= MIN_LOOKBACK_BLOCKS) {
        // Give up gracefully rather than spamming the RPC.
        return [];
      }
      lookbackBlocks = Math.max(MIN_LOOKBACK_BLOCKS, Math.floor(lookbackBlocks / 2));
      pastBlock = Math.max(0, currentBlock - lookbackBlocks);
    }
  }

  const recentLogs = logs.slice(-50).reverse();
  //console.log(recentLogs)
  // Cache token decimals for this run to avoid 50x `decimals()` calls.
  let tokenDecimals = 18;
  try {
    const token1 = new Contract(tokenCA, ERC20.abi, providerChain);
    tokenDecimals = await getDecimals(token1);
  } catch (_) {
    tokenDecimals = 18;
  }
  return Promise.all(recentLogs.map(async log => {
    try {
      const { transactionHash, args: { sender, amount0In, amount1In, amount0Out, amount1Out, to }, blockNumber } = log;

      // Get block and transaction to resolve real trader (tx.from)
      const block = await providerChain.getBlock(blockNumber);
      let txFrom;
      try {
        const tx = await providerChain.getTransaction(transactionHash);
        txFrom = tx?.from;
      } catch (_) {
        txFrom = undefined;
      }
      let txType = 'Unknown';
      let tokensAmount, ethAmount;
      if ( to === RouterChain) {
            txType = 'Sell';
            tokensAmount =  Number(amount0In) >0  ?  amount0In :  amount1In;
            ethAmount =  Number(amount0Out) > 0 ?  amount0Out :  amount1Out;
          } else {
            txType = 'Buy';
            tokensAmount =  Number(amount0Out) >0 ?  amount0Out :  amount1Out;
            ethAmount =  Number(amount0In) >0 ?  amount0In :  amount1In;
      }
      const relativeTime = getRelativeTime(block.timestamp * 1000);
      let ethDecimals = 18
      return {
        transactionHash,
        txType,
        from: txFrom ?? sender,
        tokensAmount: Math.round(Number(tokensAmount)/(10 ** Number(tokenDecimals))*1000)/1000,
        ethAmount:  Math.round(Number(ethAmount)/(10 ** ethDecimals)*1000)/1000,
        timestamp: relativeTime,
      };
    } catch (_) {
      return null;
    }
  })).then(events => events.filter(event => event !== null));
}

export async function getAmountOut(address1, address2, amountIn,chain) {
  try {
    let ProviderChain = ethprovider;
    let RouterChain = EthRouterSwap;
    const token1 = new Contract(address1, ERC20.abi, ProviderChain);
    const token2 = new Contract(address2, ERC20.abi, ProviderChain);

    const token1Decimals = await getDecimals(token1);

    const token2Decimals = await getDecimals(token2);
    const amountsOut = await RouterChain.getAmountsOut(
      ethers.parseUnits(String(amountIn), token1Decimals),
      [address1, address2]
    );

    // Use ethers.utils.formatUnits to format the output amount
    const amountOutFormatted = ethers.formatUnits(amountsOut[1], token2Decimals);

    // Convert the formatted string to a number (if desired)
    const amount_out = Number(amountOutFormatted);
    //console.log(amount_out)
    return amount_out;
  } catch (e) {
    console.log(e);
    return false;
  }
}

export async function getDecimals(token) {
  const decimals = await token
    .decimals()
    .then((result) => {
      return result;
    })
    .catch((error) => {
      return 18;
    });
  return decimals;
}

//used in lending ??
export async function getNativetoUSDC(chain) {
  let RouterSwap2 = EthRouterSwap;

  // Fetch the price of the native token against USDC
  try {
    const amountsOut = await RouterSwap2.usdcToEth(BigInt(1));
    //console.log(amountsOut)
    let price;
    price = ethers.formatUnits(amountsOut, 18); 
    return 1/price;
  } catch (error) {
    console.error("Error fetching price:", error);
    throw new Error("Failed to fetch the price");
  }
}

export async function swapTokens(
  address1,
  address2,
  amount,
  signer,
  slippage, // Slippage represented in basis points (e.g., 50 for 0.5%)
  chain
) {
   /* global BigInt */
  const network = await signer.provider.getNetwork();
  const chainId = Number(network.chainId);
  let RouterSwap2;
  let contractChain;
  if(chainId === 1){ 
    contractChain = EthcontractUni
    RouterSwap2 = EthRouterSwap.connect(signer);
  } else {
    throw Error("Wrong Chain")
  }
  console.log("address1",  address1,
    "address2", address2,
    "amount", amount,
    "signer", signer,
    "slippage", slippage, // Slippage represented in basis points (e.g., 50 for 0.5%)
    "chain", chain)

  //await getRevenu();
  let accountAddress = await signer.getAddress();
  let routerAddress = await RouterSwap2.getAddress();

  const tokens = [address1, address2];
  const time = Math.floor(Date.now() / 1000) + 300;
  const deadline = BigInt(time);
  let token1;
  token1 = new Contract(address1, ERC20.abi, signer); 
  const tokenDecimals = await getDecimals(token1);

  const amountIn = ethers.parseUnits(String(amount), tokenDecimals) ;

  const amountOut = await RouterSwap2.getAmountsOut(
    amountIn,
    tokens
  );

  const wethAddress = await RouterSwap2.WETH();

  const pairAddress = await contractChain.getPair(address1, address2);
  let pairContract;
  pairContract = new Contract(pairAddress, PAIR.abi, signer); 

  if (address1 === wethAddress) {
    const buyTotalFee = await pairContract.buyTotalFee();
    const liqFee = await RouterSwap2.usdcToEth(buyTotalFee);
    const totalValue = liqFee + amountIn;

    const amountOutMin = (amountOut[1] * BigInt(Math.round(10000 - slippage))) / BigInt(10000);

    await RouterSwap2.swapExactETHForTokensSupportingFeeOnTransferTokens(
      amountOutMin,
      tokens,
      accountAddress,
      deadline,
      { value: totalValue }
    );
  } else if (address2 === wethAddress) {
    const allowance1 = await token1.allowance(accountAddress, routerAddress);
    const usdtAddress = "0xdAC17F958D2ee523a2206206994597C13D831ec7";
    const tokenAddress = address1;

    const sellTotalFee = await pairContract.sellTotalFee();
    const liqFee = await RouterSwap2.usdcToEth(sellTotalFee);

    const amountOutMin = (amountOut[1] * BigInt(Math.round(10000 - slippage))) / BigInt(10000);
    console.log("amountOutMin", amountOutMin)
    const totalValue = (liqFee * BigInt(103)) / BigInt(100); // Equivalent to liqFee * 1.03
    if (allowance1 < amountIn) {
        if (tokenAddress.toLowerCase() === usdtAddress.toLowerCase()) {
          if (allowance1 > 0n) {
            let txZero = await token1.approve(routerAddress, 0, {
              gasLimit: 100000,
            });
            await txZero.wait();
          }
        }
      
        let tx = await token1.approve(
          routerAddress,
          ethers.MaxInt256,
          { gasLimit: 100000 }
        );
        await tx.wait();
    }


    await RouterSwap2.swapExactTokensForETHSupportingFeeOnTransferTokens(
      amountIn,
      amountOutMin,
      tokens,
      accountAddress.toString(),
      deadline,
      { value: totalValue }
    );
  }
}

// Solana Neon swapping utilities removed


//========== READ ONLY ==============

async function getPairAddressForBondedTokenForGraph(address1, address2, chain) {
  try {
    //console.log(address1, address2, chain)
    let pairAdd = await EthcontractUni.getPair(address1,address2)
    return pairAdd;
  } catch (error) {
    console.error("Error fetching pair address:", error);
  }
}

export {
  getPairAddressForBondedTokenForGraph,
  fetchRecentSwapEvents,
};
